export const ru = {
    'clear-all-areas': 'Очистить все области',
    'clear-area': 'Очистить область',
    'draw-area': 'Нарисовать область',
    'show-selected': 'Показать выбранные'
};
